import { useCallback, useState } from "react";

/** Tracks touched/submitted state for inline real-time auth form validation. */
export function useAuthFormValidation(fieldNames) {
  const [touched, setTouched] = useState({});
  const [submitted, setSubmitted] = useState(false);

  const touch = useCallback((field) => {
    setTouched((prev) => (prev[field] ? prev : { ...prev, [field]: true }));
  }, []);

  const touchAll = useCallback(() => {
    setTouched((prev) => {
      const next = { ...prev };
      fieldNames.forEach((field) => {
        next[field] = true;
      });
      return next;
    });
  }, [fieldNames]);

  const markSubmitted = useCallback(() => {
    setSubmitted(true);
    touchAll();
  }, [touchAll]);

  const shouldShow = useCallback(
    (field) => submitted || Boolean(touched[field]),
    [submitted, touched],
  );

  return { touch, markSubmitted, shouldShow };
}

export function authInputClassName(hasError) {
  const base =
    "w-full bg-white/[0.03] rounded-xl px-4 py-2.5 text-sm focus:outline-none transition-colors";
  return hasError
    ? `${base} border border-red-400/60 focus:border-red-400`
    : `${base} border border-white/10 focus:border-[#0055FF]`;
}

export function authInputClassNameLg(hasError) {
  const base =
    "w-full bg-white/[0.03] text-white rounded-xl px-4 py-3 text-sm focus:outline-none transition-colors";
  return hasError
    ? `${base} border border-red-400/60 focus:border-red-400`
    : `${base} border border-white/10 focus:border-[#0055FF]`;
}
